// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.race-concept-video {
  width: 100%;
}

.outerContainer > div:not(.race-concept-video) {
  padding-left: 100px;
  padding-right: 100px;
}
.race_concept_para,
.race_concept_para1,
.race_concept_para2,
.ready_para {
  color: #fff;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: var(--spacing-xl, 32px);
}

/* .race_concept_heading {
  color: #fff;
  font-family: Inter;
  font-size: 52px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: inline-block;
  padding: 0 !important;
  background-color: #206d23;
  position: relative;
} */



.race_concept_para1 {
  margin-top: 20px;
  margin-bottom: 130px;
}
.race_concept_para2 {
  margin-top: 34px;
}
.ready_heading {
  margin-top: 34px;
  margin-bottom: 16px;
  text-decoration: underline;
  text-decoration-color: #206d23;
  text-decoration-thickness: 3px;
}
.ready_para {
  margin-bottom: 86px;
}

@media screen and (max-width: 650px) {
  .outerContainer > div:not(.race-concept-video) {
    padding-left: 30px;
    padding-right: 30px;
  }
  .race_concept_para,
  .race_concept_para1,
  .race_concept_para2,
  .ready_para {
    font-size: 16px;
  }
  .race_concept_para1 {
    margin-bottom: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/raceconceptlearnmore/raceconcept.css"],"names":[],"mappings":"AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;;EAIE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;;;;;;;;;;GAWG;;;;AAIH;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;;;;IAIE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap\");\n.race-concept-video {\n  width: 100%;\n}\n\n.outerContainer > div:not(.race-concept-video) {\n  padding-left: 100px;\n  padding-right: 100px;\n}\n.race_concept_para,\n.race_concept_para1,\n.race_concept_para2,\n.ready_para {\n  color: #fff;\n  font-family: Roboto;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: var(--spacing-xl, 32px);\n}\n\n/* .race_concept_heading {\n  color: #fff;\n  font-family: Inter;\n  font-size: 52px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  display: inline-block;\n  padding: 0 !important;\n  background-color: #206d23;\n  position: relative;\n} */\n\n\n\n.race_concept_para1 {\n  margin-top: 20px;\n  margin-bottom: 130px;\n}\n.race_concept_para2 {\n  margin-top: 34px;\n}\n.ready_heading {\n  margin-top: 34px;\n  margin-bottom: 16px;\n  text-decoration: underline;\n  text-decoration-color: #206d23;\n  text-decoration-thickness: 3px;\n}\n.ready_para {\n  margin-bottom: 86px;\n}\n\n@media screen and (max-width: 650px) {\n  .outerContainer > div:not(.race-concept-video) {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  .race_concept_para,\n  .race_concept_para1,\n  .race_concept_para2,\n  .ready_para {\n    font-size: 16px;\n  }\n  .race_concept_para1 {\n    margin-bottom: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
